import { createReduxModule } from "hooks-for-redux";
import { StatusCodes } from "http-status-codes";
import { getMembershipContent } from "../api/get/getMembershipContentApi/getMembershipContentApi";
import {
  IGettingStartedStepResponse,
  IGreetingStepResponse,
  IMembershipContentResponse,
  IMembershipTypeStepResponse,
  IProductionStepResponse,
  IProfileStepResponse,
  IReviewStepResponse,
} from "../api/get/getMembershipContentApi/getMembershipContentApi.types";

const initialState: IMembershipContentResponse = {
  gettingStartedStep: {} as IGettingStartedStepResponse,
  greetingStep: {} as IGreetingStepResponse,
  membershipTypeStep: {} as IMembershipTypeStepResponse,
  productionStep: {} as IProductionStepResponse,
  profileStep: {} as IProfileStepResponse,
  reviewStep: {} as IReviewStepResponse,
} as IMembershipContentResponse;

export const [
  useMembershipContent,
  { setMembershipContent },
  membershipContentStore,
] = createReduxModule("membershipContent", initialState, {
  setMembershipContent: (
    membershipContent: IMembershipContentResponse,
    partialMembershipContent: IMembershipContentResponse
  ) => ({ ...membershipContent, ...partialMembershipContent }),
});

export const updateMembershipContent = async (language: string = "en") => {
  const result = await getMembershipContent(language);

  if (result?.status !== StatusCodes.OK) return result?.status;
  setMembershipContent(result.data);

  return StatusCodes.OK;
};
